import React, { useEffect, useState } from "react";
import { getTaxList } from "../Services/PayrollService";

const taxData = {
  new: {
    label: "New Regime (Sec 115BAC)",
    gross: 1412710,
    exemptions: [{ label: "HRA Exemption [Sec 10(13A)]", amt: 243132 }],
    deductions: [{ label: "Standard Deduction [Sec 16(ia)]", amt: 75000 }],
    taxable: 1264332,
    slabs: [
      { range: "0 – ₹3,00,000 @ 0%", tax: 0 },
      { range: "₹3L – ₹7L @ 5%", tax: 20000 },
      { range: "₹7L – ₹10L @ 10%", tax: 30000 },
      { range: "₹10L – ₹12L @ 15%", tax: 30000 },
      { range: "₹12L – ₹15L @ 20%", tax: 0 },
      { range: "Above ₹15L @ 30%", tax: 0 }
    ],
    baseTax: 80000,
    cess: 3200,
    total: 83200,
    monthly: 6933,
    compareLabel: "vs Old Regime",
    compareDiff: 2843,
    compareColor: "var(--success)",
    compareSign: "-"
  },
  old: {
    label: "Old Regime",
    gross: 1412710,
    exemptions: [{ label: "HRA Exemption [Sec 10(13A)]", amt: 243132 }],
    deductions: [
      { label: "Standard Deduction [Sec 16(ia)]", amt: 50000 },
      { label: "80C – PF + PPF + ELSS", amt: 43200 },
      { label: "80CCD(1B) – NPS", amt: 50000 },
      { label: "80D – Mediclaim", amt: 25000 }
    ],
    taxable: 1001378,
    slabs: [
      { range: "0 – ₹2,50,000 @ 0%", tax: 0 },
      { range: "₹2.5L – ₹5L @ 5%", tax: 12500 },
      { range: "₹5L – ₹10L @ 20%", tax: 100000 },
      { range: "Above ₹10L @ 30%", tax: 303 }
    ],
    baseTax: 112803,
    cess: 4512,
    total: 117315,
    monthly: 9776,
    compareLabel: "vs New Regime",
    compareDiff: 2843,
    compareColor: "var(--danger)",
    compareSign: "+"
  }
};

const form16Data = [
  { fy: "FY 2023-24", ay: "AY 2024-25", issued: "15 Jun 2024", regime: "New Regime", available: true },
  { fy: "FY 2022-23", ay: "AY 2023-24", issued: "12 Jun 2023", regime: "New Regime", available: true },
  { fy: "FY 2021-22", ay: "AY 2022-23", issued: "10 Jun 2022", regime: "Old Regime", available: true },
  { fy: "FY 2024-25", ay: "AY 2025-26", issued: "Will be issued by 15 Jun 2025", regime: "", available: false }
];

export const TaxTab = ({hideAmount}) => {
  const [regime, setRegime] = useState("new");
  const d = taxData[regime];

  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  
    useEffect(() => {
      fetchTaxList();
    }, []);
  
    async function fetchTaxList() {
      const req = {
        TaxId: 0,
        LoggedInEmpId: userDetails.EmpId || 0,
        OrgId: userDetails.OrgId || 0,
        GUID: "",
        EmpId: userDetails.EmpId || 0,
        PageNumber: 1,
        PageSize: 25,
        Search: "",
        TaxStatusId: "",
        TaxTypeId: "",
      };
  
      try {
        const response = await getTaxList(req);
  
        console.log(response, "response-----------");
      } catch (error) {
        console.error("Error fetching tax list:", error);
      }
    }

  const renderAmt = (value) => {
         return hideAmount ? "•••••" : `₹${value.toLocaleString("en-IN")}`;
    // if (masked) {
    //   return <span style={{ letterSpacing: '2px' }}>••••••</span>;
    // }
    // return `₹${value.toLocaleString('en-IN')}`;
  };

  return (
    <div className="tab-panel active" id="tab-tax">
      <div className="g2" style={{ alignItems: "start" }}>

        {/* LEFT */}
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>

          {/* Regime Selector */}
          <div className="sec-card">
            <div className="sec-card-head">
              <i className="fa-solid fa-scale-balanced text-brand"></i><h6>Tax Regime — FY 2024–25</h6>
            </div>

            <div className="sec-card-body">
              <div style={{ display: "flex", gap: 12 }}>

                {["new", "old"].map((r) => (
                  <div
                    key={r}
                    className={`regime-card ${regime === r ? "selected" : ""}`}
                    onClick={() => setRegime(r)}
                  >
                    <div className="regime-card-title">
                      {r === "new" ? "New Regime" : "Old Regime"}
                    </div>
                    <div className="regime-card-sub">
                      {r === "new"
                        ? `Lower slab rates. Std deduction ${renderAmt(75000)}`
                        : "Allows 80C, 80D, HRA, NPS"}
                    </div>
                  </div>
                ))}

              </div>
            </div>
          </div>

          {/* TDS Preview */}
          <div className="sec-card">
            <div className="sec-card-head">
              <i className="fa-solid fa-calculator text-brand"></i><h6>TDS Preview</h6>
            </div>

            <div className="sec-card-body">

              <div className="tax-row">
                <span>Gross Salary</span>
                <span>{renderAmt(d.gross)}</span>
              </div>

              {d.exemptions.map((e, i) => (
                <div key={i} className="tax-row tax-indent">
                  <span>Less: {e.label}</span>
                  <span>- {renderAmt(e.amt)}</span>
                </div>
              ))}

              {d.deductions.map((e, i) => (
                <div key={i} className="tax-row tax-indent">
                  <span>Less: {e.label}</span>
                  <span>- {renderAmt(e.amt)}</span>
                </div>
              ))}

              <div className="tax-row total-row">
                <span>Taxable Income</span>
                <span>{renderAmt(d.taxable)}</span>
              </div>

              <div className="tax-row">
                <span>Total Tax</span>
                <span>{renderAmt(d.total)}</span>
              </div>

              <div style={{ marginTop: 12 }}>
                <strong>Monthly TDS: ₹{renderAmt(d.monthly)}</strong>
              </div>

            </div>
          </div>

        </div>

        {/* RIGHT */}
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>

          {/* Form16 */}
          <div className="sec-card">
            <div className="sec-card-head">
              <i className="fa-solid fa-file-contract text-brand"></i><h6>Form 16</h6>
            </div>

            <div className="sec-card-body">
              {form16Data.map((f, i) => (
                <div key={i} className="f16-row" style={{ opacity: f.available ? 1 : 0.5 }}>
                  <div className="f16-icon"><i className="fa-solid fa-file-pdf" ></i></div>
                  <div className="flex:1">
                    <strong className="f16-label">{f.fy}</strong>
                    <div className="f16-sub" style={{ fontSize: 12 }}>
                      {f.ay} • {f.issued}
                    </div>
                  </div>

                  {f.available ? (
                    <button className="btn btn-light btn-sm no-print ml-auto" onClick={() => alert(`Downloading ${f.fy}`)}>
                      <i className="fa-solid fa-file-arrow-down"></i>Download
                    </button>
                  ) : (
                    <span style={{ fontSize: '11.5px', color: 'var(--text-muted)',whiteSpace: 'nowrap'}}>Not available</span>
                  )}
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}

export default TaxTab;